import React, { ReactElement, ReactText } from 'react';
import { View } from 'react-native';
import { Tappable, TappableProps } from 'src/components/Tappable/Tappable';
import useStyles from 'components/GroupHeader/GroupHeaderButton.styles';

export type PanelHeaderButtonProps = TappableProps & {
  children: ReactElement | ReactText;
};

export const GroupHeaderButton: React.FC<PanelHeaderButtonProps> = ({ children, ...props }) => {
  const s = useStyles();

  return (
    <Tappable style={[s.root, s.color]} accessibilityRole="button" {...props} hoverable>
      <View style={s.content}>{children}</View>
    </Tappable>
  );
};
